import { createSlice } from "@reduxjs/toolkit";
import { createStaff, getAllStaff } from "../staff/staffService";

const initialState = {
    allStaff: {
        isStaffLoading: null,
        isStaffSuccess: null,
        allUsersMessage: null,
        pageCount: 0,
        staff: []
    },
    newStaffMember: {
        isStaffMemberCreating: null,
        isStaffMemberCreated: null,
        staffMemberCreationMsg: null,
    },
};

const staffSlice = createSlice({
    name: 'staff',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllStaff.pending, (state) => {
                console.log("staff pending");
                state.allStaff = {
                    ...initialState.allStaff,
                    isStaffLoading: true,
                };
            })

            .addCase(getAllStaff.rejected, (state, action) => {
                console.log("staff rejected", action);
                state.allStaff = {
                    ...initialState.allStaff,
                    isStaffLoading: false,
                    isStaffSuccess: false,
                    allStaffMessage: action.payload?.message || "Error",
                };
            })

            .addCase(getAllStaff.fulfilled, (state, action) => {
                console.log("staff fulfilled", action);
                state.allStaff = {
                    ...initialState.allStaff,
                    isStaffLoading: false,
                    isStaffSuccess: true,
                    allStaffMessage: "Success",
                    pageCount: action.payload.pageCount,
                    staff: action.payload.data || [],
                };
            });

        //StaffMember creating
        builder
            .addCase(createStaff.pending, (state) => {
                state.newStaffMember = {
                    ...initialState.newStaffMember,
                    isStaffMemberCreating: true,
                    staffMemberCreationMsg: 'Loading',
                };
            })

            .addCase(createStaff.rejected, (state, action) => {
                state.newStaffMember = {
                    ...initialState.newStaffMember,
                    isStaffMemberCreating: false,
                    isStaffMemberCreated: false,
                    staffMemberCreationMsg: action.payload || 'Error occurred while creating the staffMember.',
                };
            })

            .addCase(createStaff.fulfilled, (state, action) => {
                state.newStaffMember = {
                    ...initialState.newStaffMember,
                    isStaffMemberCreating: false,
                    isStaffMemberCreated: true,
                    staffMemberCreationMsg: action.payload || 'Successfully created the staffMember.',
                };
            });
    },
})

export default staffSlice.reducer;